<template>
  <v-form class='viewWelderForm' v-model='valid' ref='viewWelderForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Name : </label>
          <p>{{ welder.name ? welder.name : '-' }}</p>
        </v-col>
        <!-- <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Passcode : </label>
          <p>{{ welder.passcode ? welder.passcode : '-' }}</p>
        </v-col> -->
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Qualification : </label>
          <p>{{ welder.qualification ? welder.qualification : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Rating : </label>
          <p>{{ welder.rating ? welder.rating : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Experience : </label>
          <p>{{ welder.experience ? welder.experience : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Salary : </label>
          <p>{{ welder.salary ? welder.salary : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Status : </label>
          <p>
            <template>
              <v-chip :color="this.welder.status == 0 ? 'success' : 'warning'" small>{{ this.welder.status == 0 ? 'Active' : 'Inactive' }}</v-chip>
            </template>
          </p>
        </v-col>
      </v-row>
      <v-footer fixed v-if="$checkRight(['edit_welder'])">
        <v-col class="text-right">
          <v-btn color="primary" class="mr-2" @click="edit" small>Edit</v-btn>
        </v-col>
      </v-footer>
    </v-container>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.$axios.post('getWelderById/' + id).then((res) => {
        this.welder = res.data.data
        console.log(this.welder)
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    } else {
      this.edit_id = undefined
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      welder: {},
      error: {}
    }
  },
  methods: {
    edit () {
      const editId = this.$route.params.id
      this.$router.push({ path: `/welder/edit/${editId}`, })
    }
  }
}
</script>

<style>
.viewWelderForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.viewWelderForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.viewWelderForm .view_label {
  font-size: 15px;
  font-weight: bold;
}
</style>
